// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.size-style.v-select .v-select__selection--comma,\n.condition-style.v-select .v-select__selection--comma {\n  color: #6C6C6C !important;\n}\n.size-style.v-text-field--outlined fieldset,\n.condition-style.v-text-field--outlined fieldset {\n  border: 1px solid #E4E4E4;\n  box-sizing: border-box;\n  border-radius: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
